var base = require('kiosk/profile');

Vue.component('spark-kiosk-profile', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/kiosk/profile.js